import axiosInstance from "../axiosInstance";

/**
 * FETCH ACTIVITY LOGS
 * @param {Object} params - Query parameters (page, limit, url, status, method)
 */
export const getActivityLogs = async (params = {}) => {
    const res = await axiosInstance.get('/admin/logs', { params });
    return res.data;
};

export const clearOldLogs = async (days = 30) => {
    const res = await axiosInstance.delete('/admin/logs/clear', { params: { days } });
    return res.data;
};

/**
 * GET DASHBOARD STATS
 */
export const getDashboardStats = async () => {
    const res = await axiosInstance.get('/admin/stats');
    return res.data;
};

/**
 * GET SYSTEM HEALTH
 */
export const getHealthStatus = async () => {
    const res = await axiosInstance.get('/admin/health');
    return res.data;
};

/**
 * ADVANCED PAYMENT VERIFICATION
 * @param {Object} data - { applicationId, email }
 */
export const verifyAdvancedPayment = async (data) => {
    const res = await axiosInstance.post('/payments/verify-advanced', data);
    return res.data;
};

/**
 * GET GLOBAL SETTINGS
 */
export const getSettings = async () => {
    const res = await axiosInstance.get('/settings');
    return res.data;
};

/**
 * UPDATE GLOBAL SETTINGS
 */
export const updateSettings = async (data) => {
    const res = await axiosInstance.put('/settings', data);
    return res.data;
};
